import { render, staticRenderFns } from "./ConveyorCard.vue?vue&type=template&id=05219625&"
import script from "./ConveyorCard.vue?vue&type=script&lang=js&"
export * from "./ConveyorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports